import React from "react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button, Popover, OverlayTrigger } from "react-bootstrap";
import "./memberRecord.css";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import Image from "../../assets/background.png";
import Header from "../../components/header/header";
import RecordCard from "../../components/recordCard/recordCard";
import { Swal } from "sweetalert2";
import Error from "../error/error";
import { AuthContext } from "../../App";
import { getUserProduct } from "../../utils/api";
import { authentication } from "../../utils/config";
import ImageBack from "../../assets/back.png";
import pictureMapping from "../../utils/pictureMapping";

const MemberRecord = () => {
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [cardData, setCardData] = useState(null);
  useEffect(() => {
    let flag = true;

    //check account
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
      flag = false;
    };

    //call getUserProduct api
    const fetchUserProduct = async () => {
      if (flag) return;
      const response = await getUserProduct(lineProfile);
      if (response.error) {
        await Swal.fire({
          title: "系統錯誤",
          text: JSON.stringify(response.data),
          icon: "error",
        });
      } else if (response.data === "not found the user") {
        await Swal.fire({
          title: "帳號不存在",
          text: "請註冊帳號",
          icon: "error",
        });
      } else if (response.data === "not found any product") {
        setCardData(null);
      } else {
        console.log(response.data[0]);

        const fetchData = response.data.map((data) => {
          const slitCode = data.product.code.split("-");
          const image = pictureMapping[slitCode[0]];
          return {
            image: image,
            date: data.createdAt.split("T")[0],
            type: data.product.code,
            name: `${data.product.typeModel.type} ${data.product.typeModel.model}`,
          };
        });
        setCardData(fetchData);
      }
      setLoading(false);
    };

    const combine = async () => {
      await auth();
      await fetchUserProduct();
    };
    combine();
  }, []);

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header
        as="h3"
        style={{ backgroundColor: "#20958F" }}
        className="text-white"
      >
        登入贈品說明
      </Popover.Header>
      <Popover.Body>
        贈品數量依據<b style={{ color: "red" }}>已登錄機器數量計算</b>
        。贈品種類多樣(指定感控藥水、免費設備保養、免上門費等服務 擇一)
        詳情歡迎LINE聯繫客服詢問!
      </Popover.Body>
    </Popover>
  );

  if (loading) {
    return <div>loading ... </div>;
  }

  return (
    <Container
      fluid
      className="vh-100 d-flex flex-column backgroundStyle"
      style={{ backgroundImage: `url(${Image})`, width: "100%" }}
    >
      <div className="text-center">
        <div className="w-100  mt-3">
          <Header title="產品購買紀錄">
            <img
              src={ImageBack}
              alt="Back"
              style={{ width: "20px", objectFit: "contain" }}
            />
          </Header>
        </div>
      </div>
      <div className="record-list mt-2">
        {!cardData && (
          <div
            className="text-center"
            style={{ height: "18vh", width: "45vh" }}
          >
            <p className="display-1">
              <b>No Data</b>
            </p>
          </div>
        )}
        {cardData &&
          cardData.map((data, index) => (
            <div key={index}>
              <RecordCard
                image={data.image}
                date={data.date}
                type={data.type}
                name={data.name}
              />
              <br></br>
            </div>
          ))}
      </div>
      <div
        className="d-flex  justify-content-center my-3 record-btn-margin mx-auto"
        style={{ width: "60%" }}
      >
        <Button
          className="btn-custom-green me-3"
          style={{ height: "50px", width: "50%" }}
          onClick={() => {
            navigate("/handadding");
          }}
        >
          手動輸入
        </Button>
      </div>
      <div className="mx-auto mt-0">
        <p
          className="fs-5"
          style={{ color: "#999C9C" }}
          onClick={() => {
            navigate("/missing");
          }}
        >
          <u>
            <b>機器號碼遺失?</b>
          </u>
        </p>
      </div>
      <div style={{ position: "fixed", bottom: "20px", right: "20px" }}>
        <OverlayTrigger trigger="click" placement="left" overlay={popover}>
          <Button className="popoverButton">?</Button>
        </OverlayTrigger>
      </div>
    </Container>
  );
};

export default MemberRecord;
